const baseUrl = (import.meta.env.VITE_API_URL || 'http://localhost:8000').replace(/\/$/, '')
let csrfReady = false

export class ApiError extends Error {
  constructor(
    message: string,
    public status: number,
    public errors: Record<string, string[]> = {},
    public code?: string,
  ) {
    super(message)
  }
}

function xsrfToken(): string | undefined {
  const item = document.cookie.split('; ').find((cookie) => cookie.startsWith('XSRF-TOKEN='))
  return item ? decodeURIComponent(item.split('=').slice(1).join('=')) : undefined
}

export async function ensureCsrf(): Promise<void> {
  if (csrfReady) return
  await fetch(`${baseUrl}/sanctum/csrf-cookie`, { credentials: 'include' })
  csrfReady = true
}

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const method = (options.method || 'GET').toUpperCase()
  if (!['GET', 'HEAD', 'OPTIONS'].includes(method)) await ensureCsrf()

  let response: Response
  try {
    response = await fetch(`${baseUrl}/api/v1${path}`, {
      ...options,
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...(xsrfToken() ? { 'X-XSRF-TOKEN': xsrfToken() as string } : {}),
        ...options.headers,
      },
    })
  } catch {
    throw new ApiError('Connexion au serveur impossible.', 0)
  }

  const payload = await response.json().catch(() => ({}))
  if (!response.ok) {
    if (response.status === 401) window.dispatchEvent(new CustomEvent('auth:expired'))
    throw new ApiError(payload.message || 'Une erreur est survenue.', response.status, payload.errors || {}, payload.code)
  }

  return payload as T
}

export { baseUrl }

